/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BasicFilter } from '@veeam-vspc/components';

import type { BasicFilterProps } from '@veeam-vspc/components';

import { useLang } from 'views/providers/LangProvider/hooks';
import { getStatusIconSrc } from 'core/utils/status-helpers';

import type { ToggleFilterStatusItem } from './interfaces';

export interface StatusToggleFilterProps<ValueT> extends Omit<BasicFilterProps<ValueT>, 'label' | 'buttons'> {
    statuses: ToggleFilterStatusItem[];
    propName?: string;
    label?: string;
}

export const StatusToggleFilter = <ValueT,>({ label, propName = 'status', statuses, ...restProps }: StatusToggleFilterProps<ValueT>) => {
    const lang = useLang();

    return (
        <BasicFilter
            {...restProps}
            name={propName}
            label={label ?? lang.STATUS}
            hasAllButton={true}
            buttons={statuses.map(({ title, value }) => ({
                title,
                value: value as any,
                icon: getStatusIconSrc(title),
            }))}
        />
    );
};
